"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Models_1 = require("../Models");

var GenericRepo_1 = __importDefault(require("./GenericRepo"));

var bson_1 = require("bson");

var DouanesRepo =
/** @class */
function (_super) {
  __extends(DouanesRepo, _super);

  function DouanesRepo(app, coll, user) {
    var _this = _super.call(this, coll, user) || this;

    _this.app = app;
    return _this;
  }

  DouanesRepo.prototype.getLast = function () {
    return this.coll.findOne({}, {
      sort: {
        created: -1
      }
    });
  };

  DouanesRepo.prototype.getLastDrm = function () {
    return this.coll.findOne({
      type: Models_1.DouaneType.DRM
    }, {
      sort: {
        created: -1
      }
    });
  };

  DouanesRepo.prototype.updateStockOutSusp = function (id, stockOutSusp) {
    var _this = this;

    return this.ensureObjectId(id).then(function (id) {
      return _this.update({
        _id: id,
        stockOutSusp: stockOutSusp
      });
    });
  };

  DouanesRepo.prototype.create = function (label, items, type) {
    var _this = this;

    return new Promise(function (res, rej) {
      var lastMap = new Map();
      var lastId = null;

      _this.getLast().then(function (last) {
        if (last) {
          lastId = last._id;
          last.items.forEach(function (v) {
            lastMap.set(v.id.toHexString(), v.stock);
          });
        }
      }).then(function () {
        var newitems = items.map(function (i) {
          var stock = lastMap.has(i._id.toHexString()) ? lastMap.get(i._id.toHexString()) : 0;
          return {
            id: i._id,
            ref: i.ref,
            label: i.label,
            place: i.place || "__UNDEFINED",
            initialStock: stock,
            stock: stock,
            packagings: __spread([{
              label: "Unité",
              multiplier: 1
            }], i.packagings.map(function (p) {
              return {
                label: p.label,
                multiplier: p.qty
              };
            }))
          };
        });

        if (type === Models_1.DouaneType.DRM) {
          return _this.buildDrmItems(newitems);
        } else {
          return {
            drmitems: [],
            items: newitems
          };
        }
      }).then(function (itemspart) {
        return _this.save(__assign({
          label: label,
          type: type,
          previous: lastId,
          next: null,
          stockOutSusp: {}
        }, itemspart)).then(function (id) {
          if (lastId) {
            _this.update({
              _id: lastId,
              next: id
            }).then(function () {
              res(id);
            });
          } else {
            res(id);
          }
        }).catch(rej);
      });
    });
  };

  DouanesRepo.prototype.getMovesSince = function (from) {
    var match = {};

    if (from) {
      match["created"] = {
        $gte: from
      };
    }

    var pipeline = [{
      $match: match
    }, {
      $unwind: {
        path: "$items"
      }
    }, {
      $sort: {
        created: 1
      }
    }, {
      $addFields: {
        in: {
          $subtract: ["$items.stock", "$items.initialStock"]
        },
        out: {
          $subtract: ["$items.stock", "$items.initialStock"]
        }
      }
    }, {
      $project: {
        items: 1,
        in: {
          $cond: [{
            $gte: ["$in", 0]
          }, "$in", 0]
        },
        out: {
          $abs: {
            $cond: [{
              $lte: ["$out", 0]
            }, "$out", 0]
          }
        }
      }
    }, {
      $group: {
        _id: {
          ref: "$items.ref",
          id: "$items.id"
        },
        startStock: {
          $first: "$items.initialStock"
        },
        endStock: {
          $last: "$items.stock"
        },
        in: {
          $sum: "$in"
        },
        out: {
          $sum: "$out"
        }
      }
    }, {
      $project: {
        ref: "$_id.ref",
        id: "$_id.id",
        in: 1,
        out: 1,
        startStock: 1,
        endStock: 1,
        _id: 0
      }
    }];
    return this.coll.aggregate(pipeline);
  };

  DouanesRepo.prototype.delete = function (o) {
    var _this = this;

    var id;

    if (o instanceof bson_1.ObjectId || typeof o === "string") {
      id = o;
    } else {
      id = o._id; // Cas d'un objet Douane
    }

    return this.ensureObjectId(id).then(function (id) {
      return _this.app.callFunction("douanesDelete", [id]);
    });
  };

  DouanesRepo.prototype.buildDrmItems = function (items) {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.getLastDrm().then(function (lastDrm) {
        _this.getMovesSince(lastDrm ? lastDrm.created : undefined).then(function (moves) {
          res({
            drmitems: moves,
            items: items
          });
        });
      });
    });
  };

  return DouanesRepo;
}(GenericRepo_1.default);

exports.default = DouanesRepo;